import VerticalOptionsMenu from './menus/VerticalOptionsMenu';

export default class PlayerGenderMenu extends VerticalOptionsMenu {
    constructor() {
        super({ options: ['Boy', 'Girl'] });
    }
}
